import React from 'react';

export const provideContext = (childContextTypes, getChildContext) => (Component) => {
  class ContextProvider extends React.Component {
    static childContextTypes = childContextTypes;

    getChildContext = () => getChildContext(this.props);

    render() {
      return <Component {...this.props} />;
    }
  }
  return ContextProvider;
};

export const consumeContext = contextTypes => (Component) => {
  /* The context is passed as props. This way the component is
   completely decoupled from the context API.
  */
  const ContextConsumer = (props, context) => <Component {...props} {...context} />;
  ContextConsumer.contextTypes = contextTypes;
  return ContextConsumer;
};
